import { Component, OnInit } from '@angular/core';
declare var $: any;
import { ActivatedRoute, Router } from "@angular/router";
import { Globals } from '../../globals';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TemplatesService, EmailTemplateDto, LocalizationsEmailTemplate } from 'app/services/template/TemplatesService';
import { AdminService } from 'app/services/admin/AdminService';
import { AssessmentsService } from 'app/services/assessment/AssessmentsService';


@Component({
    selector: 'app-new-email-template',
    templateUrl: './new-email-template.component.html',
    styleUrls: ['./new-email-template.component.scss']
})
export class NewEmailTemplateComponentCopy1 implements OnInit {
    name: string;
    purpose: string;
    type: string;
    niche: string;
    userType: number;
    fieldsOpen: boolean = true;
    fieldsModified: boolean = false;
    purposes: any[] = [];
    niches: any[] = [];
    languages: any[] = [];

    public editor;
    public editorContent = ``;
    public editorOptions = { placeholder: "insert content..." };

    templateFields: any[] = [];
    htmlBody: string = null;
    localizations: LocalizationsEmailTemplate[] = [];
    templateId: number = 0;

    selectedType = "Regular";

    userTypes: any[] = [];

    form: FormGroup;
    modules = {};
    text: string = "";
    range: any;
    editorInstance: any;
    assessmentsTypes: any[] = [];

    constructor(
        private _AdminService: AdminService,
        private _TemplatesService: TemplatesService,
        private activatedRoute: ActivatedRoute,
        private _Globals: Globals,
        private toastr: ToastrService,
        fb: FormBuilder,
        private _router: Router,
        private _AssessmentsService: AssessmentsService
    )
    {
        this.activatedRoute.params.subscribe(params => {
            console.log("PARAMS", params);
            let isEmpty = jQuery.isEmptyObject(params);
            if (isEmpty) {
                this.templateId = 0;
            } else {
                this.templateId = parseInt(params['id']); 
            }
            
            //console.log('name',this.name);
        });


        this.form = fb.group({
            editor: ['test']
        });

    }

    ngOnInit() {
      //  setTimeout(() => {
      //    //this.editorContent = '';
      //    //this.editorContent = '<h1><span style="color: rgb(230, 0, 0);">content </span><span style=background-color: rgb(255, 255, 102)>changed</span>!</h1>';
      //    //console.log('you can use the quill instance object to do something', this.editor);
      //    var container = this.editor.addContainer('ql-custom');
      //    // this.editor.disable();
      //}, 2800);
        //console.log("status", this.fieldsOpen);

        this.getTemplateFields();
        this.getTemplatePurposes();
        this.getNiches();
        this.getAssessmentTypes();
        this.getLanguages();
        if (this.templateId != 0) {
            this.getEmailTemplate();
        }
        //this.getUserTypes();   
        this.getUserTypesByTemplateType();
        
    }

    getAssessmentTypes() {
        this._AssessmentsService.getAssessmentTypes().subscribe((data: any) => {
            console.log('getAssessmentTypes', data.result);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.assessmentsTypes = _data;
                console.log(_data);
                //this.loading = false;
            }
        })
    }

    getSelectedOptionText(event: Event) {
        let selectElementText = event.target['options']
        [event.target['options'].selectedIndex].text;
        console.log(selectElementText);
        this.selectedType = selectElementText;
    }


    getEmailTemplate() {
        this._TemplatesService.getEmailTemplate(this.templateId).subscribe((data: any) => {
            //console.log('response_GetEmailTemplate', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetEmailTemplate', _data);

                this.name = _data.Name;
                this.purpose = _data.Purpose;
                this.type = _data.AssessmentType;
                this.niche = _data.Niche;
                this.localizations = _data.Localizations;
                this.htmlBody = this.localizations[0].Body;
                this.checkData(this.localizations[0].Language, this.localizations[0].Subject);
                this.userType = _data.UserType;
            }
        });
    }

    getTemplateFields() {
        this._AdminService.getTemplateFields().subscribe(data => {
            console.log('response_GetTemplateFields', data.result);
            this.templateFields = data.result;
        });
    }

    getUserTypes() {
        this._AdminService.getUserTypes().subscribe((data: any) => {
            console.log('response_GetUserTypes', data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.userTypes = _data;
            }
        });
    }

    getUserTypesByTemplateType() {
        this._AdminService.getUserTypesByTemplateType(1).subscribe((data: any) => {
            console.log('response_GetUserTypes', data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.userTypes = _data;
            }
        });

    }

    getTemplatePurposes() {
        this._AdminService.getTemplatePurposes().subscribe((data: any) => {
            console.log('response_GetTemplatePurposes', data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                this.purposes = JSON.parse(data.result.Data);
            }
        });
    }

    getNiches() {
        this._AdminService.getNiches().subscribe((data: any) => {
            console.log('respons_GetNiches', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.niches = _data;
            }
        });
    }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
            console.log('response__GetLanguages', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.languages = _data;
            }
        })
    }

    //insertCustomText() {

    //    var length = this.editor.getLength();

    //    this.editor.insertText(length-1, '<h1>Hello</h1>', 'bold', true);

    //    //this.editor.insertText(5, 'Quill', {
    //    //    'color': '#ffff00',
    //    //    'italic': true
    //    //});
    //}

    //insertCustomImages() {
    //    var range = this.editor.getSelection();
    //    if (range) {
    //        if (range.length == 0) {
    //            console.log('User cursor is at index', range.index);
    //        } else {
    //            var text = this.editor.getText(range.index, range.length);
    //            console.log('User has highlighted: ', text);
    //        }
    //        this.editor.insertEmbed(range.index, 'image', 'https://quilljs.com/images/cloud.png');
    //    } else {
    //        console.log('User cursor is not in editor');
    //    }

    //    var length = this.editor.getLength();
    //}

    insertCustomFields(fieldName: string) {
        var range = this.editor.getSelection();
        if (range) {
            if (range.length == 0) {
                console.log('User cursor is at index', range.index);
            } else {
                var text = this.editor.getText(range.index, range.length);
                console.log('User has highlighted: ', text);
            }
            this.editor.insertText(range.index, `{${fieldName}}`, 'bold', true);

        } else {
            console.log('User cursor is not in editor');

            var length = this.editor.getLength();

            this.editor.insertText(length - 1, `{${fieldName}}`, 'bold', true);
        }

    }

    createInstance(editorInstance) {
            this.editorInstance = editorInstance;
    }

    onContentChanged({ html, text }) {
        //console.log('quill content is changed!', quill, html, text);
        this.htmlBody = html;
        this.text = text;
        console.log('html body', this.htmlBody);
    }

    logSelection($event: any) {
        this.range = $event.range;
        console.log('$event', $event);
        console.log('range', this.range);
        this.createInstance($event.editor);
    }

    addBindingCreated(quill) {
        quill.keyboard.addBinding({
            key: 'b'
        }, (range, context) => {
            console.log('KEYBINDING B', range, context);
        });

        quill.keyboard.addBinding({
            key: 'B',
            shiftKey: true
        }, (range, context) => {
            console.log('KEYBINDING SHIFT + B', range, context);
        });
    }

    onEditorBlured(quill) {
        console.log('editor blur!', quill);
    }

    onEditorFocused(quill) {
        console.log('editor focus!', quill);
    }

    onEditorCreated(quill) {
        this.editor = quill;
        console.log('quill is ready! this is current quill instance object', quill);
        this.createInstance(quill.clipboard.quill);
    }

    public options: Object = {
        charCounterCount: true,
        toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', 'my_dropdown']
    };

    changeTitle( status ) {
      
        this.fieldsOpen = !status;
        console.log("status", this.fieldsOpen);
        if (this.fieldsOpen) {
            $('.fieldsTitle a').text('Details');
        } else {
            $('.fieldsTitle a').text('Details - [' + $("#aType option:selected").text() + ' | ' + $("#aNiche option:selected").text() + ' | ' + $("#aPurpose option:selected").text() + ']');
        }
    }

    //setControl() {
    //    this.form.setControl('editor', new FormControl('test - new Control'))
    //}

    //setFocus($event) {
    //    $event.focus();
    //}

    //patchValue() {
    //    this.form.controls['editor'].patchValue(`${this.form.controls['editor'].value} patched!`)
    //}

    //toggleReadOnly() {
    //    this.isReadOnly = !this.isReadOnly;
    //}

    logChange($event: any) {
        console.log('logChange', $event);
    }


    //delete() {
    //    let mode = this._Globals.getMode();
    //    console.log("mode", mode);
    //    switch (mode) {
    //        case "Administrator":
    //            this._router.navigate(['/app/emailtemplates']);
    //            break;
    //        case "Coach":
    //            this._router.navigate(['/app/cemails']);
    //            break;
    //    }
    //}

    

    //load localization
    checkData(languageShortCode: string, subject: string) {

        //if (subject == "") {
        //    this.toastr.warning('Subject field empty', 'ELI');
        //    return;
        //}

        //if (this.htmlBody == null) {
        //    this.toastr.warning('Email body empty', 'ELI');
        //    return;
        //}

        $('#subject').val('');
        this.editorContent = '';

        //this.clearTextArea();
        console.log('check data', this.localizations);

        //check array for display data in text area if exist
        let exist = false;
        let pos = 0;
        for (var i = 0; i < this.localizations.length; i++) {
            if (languageShortCode == this.localizations[i].Language) {
                exist = true;
                pos = i;
            }
        }
        if (exist) {
            //load html content editor
            //load subject
            $('#subject').val(this.localizations[pos].Subject);
            this.editorContent = this.localizations[pos].Body;
            console.log('LOCALIZATION VALUES:', this.localizations[pos].Subject, this.localizations[pos].Body);
        }

        $(".panel-body").focus();

    }

    addLocalization(shortCode: string, subject:string) {
        //if (text != '') {
        console.log('addLocalization');
        if (subject == "") {
            this.toastr.warning('Subject field empty', 'ELI');
            return;
        }
       
        if (this.localizations.length == 0) {
            let newLocalization = new LocalizationsEmailTemplate();
            newLocalization.Language = shortCode;
            newLocalization.Subject = subject;
            newLocalization.Body = this.htmlBody;

            this.localizations.push(newLocalization);
        }
        else {
            
            let addNew = true;
            for (var i = 0; i < this.localizations.length; i++) {
                if (this.localizations[i].Language == shortCode) {
                    //property exist
                    addNew = false;
                    this.localizations[i].Body = this.htmlBody;
                    this.localizations[i].Subject = subject;
                }
            }
            if (addNew) {
                //property not exist
                let newLocalization = new LocalizationsEmailTemplate();
                newLocalization.Language = shortCode;
                newLocalization.Subject = subject;
                newLocalization.Body = this.htmlBody;

                this.localizations.push(newLocalization);
            }
        }
        console.log(this.localizations);
        //}
    }

    saveTemplate(name: string, type: string, purpose: string, niche: string, userType: string) {

        if (name == "") {
            this.toastr.warning('Name field empty', "ELI");
            return;
        }


        //adding localization if user not change the select
        let shortCode = $('#languages').val();
        let subject = $('#subject').val();
        this.addLocalization(shortCode, subject);

        if (this.htmlBody == null) {
            this.toastr.warning('Email body empty', 'ELI');
            return;
        }


        let enLocalization = false;

        if (this.localizations.length == 0) {
            this.toastr.warning('No localizations set', "ELI");
            return;
        } else {
            for (var i = 0; i < this.localizations.length; i++) {
                if (this.localizations[i].Language == "en") {
                    enLocalization = true
                }
            }            
        }

        if (!enLocalization) {
            this.toastr.warning('English localization missing', 'ELI');
            return;
        }

        
        
        let emailTemplate = new EmailTemplateDto();
        emailTemplate.TemplateId = this.templateId;
        emailTemplate.Name = name;
        emailTemplate.AssessmentType = parseInt(type);
        emailTemplate.Purpose = parseInt(purpose);
        emailTemplate.Niche = parseInt(niche);
        emailTemplate.Owner = this._Globals.getUserId();
        emailTemplate.Localizations = this.localizations;
        emailTemplate.UserType = parseInt(userType);
        emailTemplate.IsGlobal = true;

        console.log('EMAIL TEMPLATE', emailTemplate);

        this._TemplatesService.postSaveEmailTemplate(emailTemplate).subscribe(data => {
            console.log('response_PostSaveEmailTemplate', data);

            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    this.toastr.success('Email template saved successfully','ELI');
                }

                if (data.result.Result == 0) {
                    this.toastr.error('We are sorry. An error happened while trying to save the email template.', 'ELI');
                }
            }
        });


    }

    preventSpace(value: string, event: any) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $('#subject').val('');
        }
    }

    deleteEmailTemplate() {
        this._AdminService.postDeleteEmailTemplate(this.templateId).subscribe((data: any) => {
            console.log('response_deleteEmailTemplate', data);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result === 1) {
                    this.toastr.success('Email Template deleted successfully.', 'ELI');
                    this._router.navigate(['/app/emailtemplates']);
                } else if (data.result.Result < 0) {
                    this.toastr.warning('This template cannot be deleted because it is being used either in an assessment or assignment.', 'ELI');
                    this.closeModalConfirmation();
                }
            }
        });
    }

    /*Confirmation Delete*/
    openConfirmationModal() {
        $("#confirmationDeleteModal").modal({ backdrop: "static" });
        $('#confirmationDeleteModal').modal('show');

    }

    closeModalConfirmation() {
        $('#confirmationDeleteModal').modal('hide');
    }

}
